import productReportGroupApi from "../../api/report/productReportGroupApi";

export interface ProductReportGroupSavePayload {
    name: string;
    productIds: number[];
}

const ProductReportGroupService = {

    /** GET /api/product-report-groups */
    getAll: async () => {
        const response = await productReportGroupApi.fetchAll();
        return response.data;
    },

    /** GET /api/product-report-groups/dropdown (solo activos) */
    getActive: async () => {
        const response = await productReportGroupApi.fetchCustom("/dropdown");
        return response.data;
    },

    /** GET /api/product-report-groups/{id} */
    getById: async (id: number) => {
        const response = await productReportGroupApi.fetchById(id);
        return response.data;
    },

    /** POST /api/product-report-groups */
    create: async (data: ProductReportGroupSavePayload) => {
        const response = await productReportGroupApi.add(data);
        return response.data;
    },

    /** PUT /api/product-report-groups/{id} */
    update: async (id: number, data: ProductReportGroupSavePayload) => {
        const response = await productReportGroupApi.modify(id, data);
        return response.data;
    },

    /** PATCH /api/product-report-groups/{id}/toggle-status */
    toggleStatus: async (id: number) => {
        const response = await productReportGroupApi.patchCustom(`${id}/toggle-status`);
        return response.data;
    },

};

export default ProductReportGroupService;
